import ZoneSetupMap from './ZoneSetupMap';

export default ZoneSetupMap;
